// extracted by mini-css-extract-plugin
export default {"brandPromo":"gN-z","carousel":"hN-z"};